/* global YT */

const SELECTOR = '[data-youtube-id]';

export function init() {
    const elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) {
        return;
    }

    function getYouTubeEmbedId(url) {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S+\/\S+\/|\S+\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        return match ? match[1] : null;
    }

    elements.forEach(node => {
        const youtubeUrl = node.getAttribute('data-youtube-id');
        if (youtubeUrl) {
            const embedId = getYouTubeEmbedId(youtubeUrl);
            if (embedId) {
                node.setAttribute('data-youtube-id', embedId);
                node.setAttribute('id', 'youtube-' + embedId);
            }
        }
    });

    window.onYouTubeIframeAPIReady = () => {
        elements.forEach(node => {
            const videoId = node.getAttribute('data-youtube-id');
            let initialPlay = true;

            const player = new YT.Player(node.id, {
            videoId: videoId,
            playerVars: {
                controls: node.getAttribute('data-show-controls') || 0,
                autoplay: 1,
                mute: 1,
                disablekb: node.getAttribute('data-disable-keyboard') || 0,
                enablejsapi: 1,
                iv_load_policy: 3,
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
                height: node.getAttribute('data-width') || '1200',
                width: node.getAttribute('data-height') || '675'

            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
            });

            function updateButtons(playing) {
                const pauseButtons = document.querySelectorAll('.btn--pause');
                pauseButtons.forEach(btn => {
                    btn.classList.toggle('paused', !playing);
                    const span = btn.querySelector('span');
                    if (span) span.textContent = playing ? 'Pause' : 'Play';
                    const div = btn.querySelector('div');
                    if (div) {
                        div.innerHTML = playing
                            ? '<svg class="o-icon o-icon--circle-pause"><use xlink:href="#circle-pause"></use></svg>'
                            : '<svg class="o-icon o-icon--play-circle"><use xlink:href="#play-circle"></use></svg>';
                    }
                });
            }

            // 4. The API will call this function when the video player is ready.
            function onPlayerReady() {
                player.playVideo();

                const pauseButtons = document.querySelectorAll('.btn--pause');
                pauseButtons.forEach(btn => {
                    btn.addEventListener('click', e => {
                        e.preventDefault();

                        // Preserve scroll position: player.playVideo() internally calls
                        // scrollIntoView() on the iframe, causing the page to jump.
                        const scrollY = window.scrollY;

                        if (player.getPlayerState() === YT.PlayerState.PLAYING) {
                            player.pauseVideo();
                        } else {
                            player.playVideo();
                        }

                        window.scrollTo(window.scrollX, scrollY);
                    });
                });
            }

            // 5. The API calls this function when the player's state changes.
            //    The function indicates that when playing a video (state=1),
            //    the player should play for six seconds and then stop.
            function onPlayerStateChange(event) {
                if (event.data === YT.PlayerState.PLAYING) {
                    updateButtons(true);
                    if (initialPlay) {
                        player.seekTo(0);
                        document.getElementById(node.id).classList.add('video-container--loaded');
                        const heroEl = node.closest('.js-header-video');
                        if (heroEl) {
                            setTimeout(() => heroEl.classList.add('header-video--loaded'), 500);
                        }
                        initialPlay = false;
                    }
                }

                if (event.data === YT.PlayerState.PAUSED) {
                    updateButtons(false);
                }

                if (event.data === YT.PlayerState.ENDED) {
                    player.seekTo(0);
                    player.playVideo();
                }
            }
        });
    }

    // Insert JS tag (<script src="https://www.youtube.com/iframe_api"></script>)
    const tag = document.createElement('script');
    tag.setAttribute('src', 'https://www.youtube.com/iframe_api');
    document.head.appendChild(tag);
}
